import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GeneralService } from './general/general.service';
import { environment } from '@asambleas-env/environment';

@Injectable()
export class CredentialRenovationsService {

  constructor(private http: HttpClient,
    private _generalService: GeneralService) { }

  getCredentialRenovation(id: number) {

    return this.http.get(environment.apiEndPoint + '/credential-renovations/' + id, this._generalService.getHeadersUser());
  }

  toProduction(data) {
    return this.http.post(environment.apiEndPoint + '/credential-renovations/paso-produccion', data, this._generalService.getHeadersUser());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/credential-renovations.service.ts